import * as yup from 'yup';
import { PartnersEnum } from 'entities/Partners/enums';

export const PartnersValidationSchema = yup.object({
	name: yup.string().required('auth.validation.enter_company_name'),
	vatNumber: yup.string(),
	address: yup.string(),
	type: yup
		.mixed<PartnersEnum>()
		.oneOf(Object.values(PartnersEnum))
		.required('partners.validation.client_supplier'),
	erpCode: yup.string(),
	note: yup.string(),
	emails: yup.array(),
	destinations: yup.array().of(
		yup.object({
			receiverName: yup.string(),
			receiverAddress: yup.string().required('shared_texts.field_is_required'),
			receiverId: yup.string().required('shared_texts.field_is_required'),
		}),
	),
});

export const PartnerInfoForReplaceValidationSchema = yup.object({
	name: yup.string(),
	vatNumber: yup.string(),
	address: yup.string(),
	erpCode: yup.string(),
});
